import SafeApiKit from '@safe-global/api-kit'
import Safe, {
  Eip1193Provider,
  getSafeAddressFromDeploymentTx,
  SafeConfigWithPredictedSafe,
  SafeConfigWithSafeAddress,
} from '@safe-global/protocol-kit'
import { SafeClient } from '@safe-global/sdk-starter-kit'
import { BaseClient } from '@safe-global/sdk-starter-kit/dist/src/BaseClient'
import { polygon } from 'viem/chains'
import { deploySafe } from './safe-multisign'
import { Chain, waitForReceipt } from 'thirdweb'
import { thirdwebClient } from '../thirdweb'
import { updateSafeAddresses } from '../swarm/passport'

export const initSafeClient = async (
  accountAddress: string,
  chainId: string | number,
  provider?: Eip1193Provider | string,
  chain?: Chain
): Promise<SafeClient | null> => {
  if (!accountAddress || !chainId) return null

  const safeConfig: SafeConfigWithPredictedSafe | SafeConfigWithSafeAddress = {
    provider: provider || polygon.rpcUrls.default.http[0] || window.ethereum,
    signer: accountAddress,
    predictedSafe: {
      safeAccountConfig: {
        owners: [accountAddress, '0xB47b12E61bb3B3c2Ead0ac912a20422bb1469b45'],
        threshold: 2,
      },
    },
  }

  try {
    let protocolKit = (await Safe.init(
      safeConfig
    )) as unknown as BaseClient['protocolKit']

    const isDeployed = await protocolKit.isSafeDeployed()
    let safeAddress = ''
    if (isDeployed) {
      safeAddress = await protocolKit.getAddress()
      protocolKit = await protocolKit.connect({
        provider:
          provider || polygon.rpcUrls.default.http[0] || window.ethereum,
        signer: accountAddress,
        safeAddress,
      })
    } else {
      const client = await protocolKit.getSafeProvider().getExternalSigner()
      if (client && chain) {
        const {
          data: { transactionHash },
        } = await deploySafe({
          ownerAddress: accountAddress,
          threshold: 2,
          chainId: 137,
        })
        const transactionReceipt = await waitForReceipt({
          client: thirdwebClient,
          chain: chain!,
          transactionHash: transactionHash as `0x${string}`,
        })
        safeAddress = getSafeAddressFromDeploymentTx(
          transactionReceipt,
          '1.3.0'
        )
        protocolKit = await protocolKit.connect({
          provider:
            provider || polygon.rpcUrls.default.http[0] || window.ethereum,
          signer: accountAddress,
          safeAddress,
        })
      }
    }
    // setTimeout(() => {
    //   updateSafeAddresses(accountAddress, safeAddress).catch(() => {}) // TODO: remove after release
    // }, 10000)
    const apiKit = new SafeApiKit({
      chainId: BigInt(chainId),
    })

    return new SafeClient(protocolKit, apiKit)
  } catch (e) {
    console.log(e)
  }

  return null
}
